// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"505602fd0de6f9cf9745","305":"e098f454ea755d787e83","526":"9d256b9966affc487ece","777":"6a8bbe6b23ddb14e30fa"}[chunkId] + ".js";
};